/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".drawing-canvas[_ngcontent-%COMP%]{border:2px solid #000;display:block;margin:0 auto}button.btn[_ngcontent-%COMP%]{margin:10px 5px;min-width:20%}"];
export { styles as styles };
